// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2XYV1","box":"WorkspacesBox_box__3HLz2","node":"WorkspacesBox_node__aDESP"};